import { render } from "./SurveyDetailComponent.vue?vue&type=template&id=04f7405f"
import script from "./SurveyDetailComponent.vue?vue&type=script&lang=js"
export * from "./SurveyDetailComponent.vue?vue&type=script&lang=js"

import exportComponent from "/builds/phi-indonesia/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__